import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'LineItemReference',
  props: {
    index: null,
    reference: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({(e: 'input', payload: any): void}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    index: number,
    reference?: string
}




function updateReference(input) {
    emit('input', { index: props.index, reference: input });
}

return { __sfc: true,props, emit, updateReference }
}

})